import { render, staticRenderFns } from "./ModalCategory.vue?vue&type=template&id=26c6a8df&scoped=true&"
import script from "./ModalCategory.vue?vue&type=script&lang=js&"
export * from "./ModalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c6a8df",
  null
  
)

export default component.exports